export enum GrantType {
  PASSWORD = 'password'
}
